@if (label) {
  <app-control-header
    [required]="required"
    [labelWithColon]="labelWithColon"
    [label]="label"
  ></app-control-header>
}
<div class="inline-flex items-center cursor-pointer gap-x-2" (click)="onClick($event)">
  <svg class="w-9 h-full" width="36"  height="18" viewBox="0 0 36 18" fill="none" xmlns="http://www.w3.org/2000/svg" [class.off]="!value">
    <rect width="36" height="18" rx="9" fill="#053956" [ngClass]="{ 'hover:fill-navy-90': value }" />
    <circle cx="27" cy="9" r="6" fill="white" [ngClass]="{ 'transform -translate-x-0': value, 'transform -translate-x-1/2': !value }" />
  </svg>

  @if (textTranslationKey) {
    <span class="font-main text-base {{ value ? 'text-navy-90 font-bold' : 'text-navy-70' }}">
      {{ textTranslationKey | translate }}
    </span>
  }
</div>

@if (descriptionTranslationKey) {
  <div class="font-main text-base text-navy-70 mt-2">
    {{ descriptionTranslationKey | translate }}
  </div>
}
